import { ELEMENT_IDS } from 'fitify-ui-landing/src/@types/constants'
import { Text } from 'fitify-ui-landing/src/components/Text'
import { useTranslation } from 'next-i18next'

import {
  StyledFeaturesContainer,
  StyledFeaturesSection,
  StyledTextWrapper,
} from '@/components/blocks/Features/Features.Styled'
import type { FeatureItem } from '@/data/features'
import { getLocalizedImagePathConverter } from '@/utils/getLocalizedImagePathConverter'

import Feature from './Feature'

const Features = ({ items }: { items: FeatureItem[] }) => {
  const { t, i18n } = useTranslation()

  return (
    <StyledFeaturesSection id={ELEMENT_IDS.features}>
      <StyledFeaturesContainer>
        <StyledTextWrapper>
          <Text
            as="h2"
            color="Blue900"
            variant="header-title"
            html={t('cl_landing_highlights_block_title')}
          />
        </StyledTextWrapper>
        {items.map((item: FeatureItem, index: number) => {
          const localizedImage = getLocalizedImagePathConverter(
            {
              imageSrc: item.image,
              imageSrcSet: item.imageSet,
            },
            i18n.language
          )
          return (
            <Feature
              key={'feature_' + index}
              title={t(item.title)}
              image={localizedImage.src}
              imageSet={localizedImage.srcSet}
              content={t(item.content)}
              isEven={index % 2 === 0}
              imageAssets={item.imageAssets}
              headlineVariant={'dg-feature-title' as TextTypesVariants}
              ctaButton={item.ctaButton}
            />
          )
        })}
      </StyledFeaturesContainer>
    </StyledFeaturesSection>
  )
}

export default Features
